module.exports = __webpack_public_path__ + "static/media/xfiles.b2af02bd.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xfiles.mp3
// module id = 42
// module chunks = 0